import { render } from "./TicketMonitoring.vue?vue&type=template&id=1ddf84aa&scoped=true"
import script from "./TicketMonitoring.vue?vue&type=script&lang=js"
export * from "./TicketMonitoring.vue?vue&type=script&lang=js"

import "./TicketMonitoring.vue?vue&type=style&index=0&id=1ddf84aa&lang=scss&scoped=true"

import exportComponent from "E:\\xlckj\\大屏\\monitor\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddf84aa"]])

export default __exports__